document.addEventListener('submit', async function (e) {
    if (e.target.id !== 'formAgregarProduccionInyeccion') return;

    e.preventDefault();

    const formulario = e.target;
    const modalPadre = formulario.closest('.modal');
    const btnSubmit = formulario.querySelector('#btnAgregarProduccionInyeccion');
    const spinner = formulario.querySelector('#spinner');

    // Validación HTML nativa antes de enviar
    if (!formulario.checkValidity()) {
        formulario.reportValidity();
        return;
    }

    // Evitar doble submit
    if (btnSubmit) btnSubmit.disabled = true;
    if (spinner) spinner.style.display = 'inline-block';

    formulario.querySelectorAll('.inputRojo').forEach(function (input) {
        input.classList.remove('inputRojo');
    });

    try {
        const formData = new FormData(formulario);

        const respuesta = await fetch('/api/inyeccion/agregar-produccion', {
            method: 'POST',
            body: formData,
            credentials: 'include'
        });

        let json = null;

        try {
            json = await respuesta.json();
        } catch (errorJson) {
            throw new Error('La respuesta del servidor no es JSON válido.');
        }

        if (!respuesta.ok) {
            console.error('Error HTTP:', respuesta.status, json);
            lanzarAlerta('Error al procesar la solicitud.', 'alerta-roja');
            return;
        }

        if (!json || !json.result) {
            console.error('Respuesta inesperada:', json);
            lanzarAlerta('Respuesta inesperada del servidor.', 'alerta-roja');
            return;
        }

        const resultado = json.result;

        if (resultado.hayErrores) {
            if (Array.isArray(resultado.errores)) {
                resultado.errores.forEach(function (error) {
                    if (typeof lanzarAlerta === 'function') {
                        lanzarAlerta(error.mensaje || 'Error de validación.', error.clase || 'alerta-roja');
                    }

                    if (error.campo) {
                        const campo = formulario.querySelector('[name="' + error.campo + '"]');
                        if (campo) campo.classList.add('inputRojo');
                    }
                });
            }
            return;
        }

        const inputReporte = formulario.querySelector('#idEncabezadoReporteInyeccion');
        const idReporte = inputReporte ? inputReporte.value : '';
        const params = new URLSearchParams(window.location.search);
        const mes = params.get('mes');
        const anio = params.get('año');

        formulario.reset();

        if (modalPadre) {
            modalPadre.classList.remove('modal--show');
        }

        if (window.location.pathname === '/inyeccion/periodo') {
            if (typeof window.actualizarModalReporteInyeccion === 'function') {
                window.actualizarModalReporteInyeccion(idReporte);
            }

            if (typeof window.actualizarTableroInyeccionPeriodo === 'function') {
                window.actualizarTableroInyeccionPeriodo(mes, anio);
            }

            if (typeof window.actualizarTablaInyeccionPeriodo === 'function') {
                window.actualizarTablaInyeccionPeriodo(mes, anio);
            }
        }

        if (window.location.pathname === '/zona-trabajo') {
            if (typeof window.actualizarZonaTrabajo === 'function') {
                if (window.location.pathname === "/zona-trabajo") window.actualizarZonaTrabajo();
            }

            if (typeof window.actualizarModalReporteInyeccion === 'function') {
                window.actualizarModalReporteInyeccion(idReporte);
            }
        }

        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta('Registro guardado con éxito.', 'alerta-verde');
        }

    } catch (error) {
        console.error('Error:', error);

        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta('Error crítico al procesar la solicitud.', 'alerta-roja');
        } else {
            alert('Error crítico al procesar la solicitud.');
        }

    } finally {
        if (btnSubmit) btnSubmit.disabled = false;
        if (spinner) spinner.style.display = 'none';
    }
});